import type { CanonicalCut, IntegerProblem } from '@/core/cuts'
import { customProblemEditor } from '@/game/custom-editor'

class MathPanelAdapter {
  public currentProblem: IntegerProblem | null = null
  private onProblemUpdated: ((problem: IntegerProblem) => void) | null = null

  constructor() {
    customProblemEditor.onProblemCreate((problem: IntegerProblem) => {
      this.currentProblem = problem
      if (this.onProblemUpdated) {
        this.onProblemUpdated(problem)
      }
    })
  }

  setOnProblemUpdated(callback: (problem: IntegerProblem) => void): void {
    this.onProblemUpdated = callback
  }

  renderProblem(problem: IntegerProblem): void {
    this.currentProblem = problem
  }

  show(): void {
    // Display is owned by React MathPanel.
  }

  hide(): void {
    // Display is owned by React MathPanel.
  }

  toggle(): void {
    // Display is owned by React MathPanel.
  }

  showCurrentCut(_cut: CanonicalCut): void {
    // Cut formula rendering is owned by React panels.
  }

  hideCurrentCut(): void {
    // Cut formula rendering is owned by React panels.
  }

  safeRerenderMath(): void {
    // MathJax is removed; no-op kept for compatibility.
  }
}

export const mathRenderer = new MathPanelAdapter()
